"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.REGISTERED_CONSULTANT_EVENT = void 0;
const REGISTERED_CONSULTANT_EVENT = exports.REGISTERED_CONSULTANT_EVENT = 'registerConsultant';